import React from 'react';

import { Title as PrismTitle } from '@nutanix-ui/prism-reactjs';
import {
  TitleAppearance,
  type TitleProps as PrismTitleProps,
  TitleSizes,
} from '@nutanix-ui/prism-reactjs/lib/components/v2/Typography/Title';

export type TitleProps = PrismTitleProps;
export { TitleSizes, TitleAppearance };

export default function Title(props: React.PropsWithChildren<TitleProps>) {
  return <PrismTitle {...props} />;
}
